<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入院校名称" v-model="school_name" @keyup.enter.native="searchName" class="input-with-select">
        <el-button slot="append" @click="searchName">
          <img src="@/assets/img/home/search.png" alt="" />
        </el-button>
      </el-input>
    </div>

    <div v-if="SearchList.length > 0" class="search-list">
      <div class="search-list-content">
        <div class="search-title search-list-item color-2">已选院校：</div>
        <div class="search-list-item border-2 " v-for="(item, i) in SearchList" :key="i">
          {{ item }}
        </div>
      </div>
      <div class="toSearch search-list-item">
        <el-button size="mini" @click="onSearch">开始对比</el-button>
      </div>

    </div>

    <div class="refulsh" @click="getRefulsh">
      <div>
        推荐院校
      </div>
      <div class="huanyipi">
        换一批 <i class="iconfont luming-pc-shuaxin" style="font-size: 22px; margin-right: 15px; "></i>
      </div>
    </div>

    <div class="school-item border-1" @click="addSchool(item)" v-for="(item, key) in SchoolList" :key="key">
      <div style="position: absolute; right: 120px; color: #0a98ff;" v-if="item.score_update == 1">
        <img src="@/assets/img/update.png" width="20px" alt="" style="position: relative;top: 5px;" />
        专业已更新
      </div>

      <div class="school-logo">
        <el-avatar :size="75" :src="item.logo" />
      </div>
      <div class="school-info">
        <div class="school-name">
          {{ item.name }}
        </div>
        <div class="school-desc">
          <span v-if="item.school_id && item.school_id != '999999'">{{ item.school_id }}</span>
          <span v-if="item.school_belong">/{{ item.school_belong }}</span>
          <span v-if="item.school_nature">/{{ item.school_nature }}</span>
          <span v-if="item.address">/{{ item.address }}</span>
          <span v-if="item.school_type">/{{ item.school_type }}</span>
        </div>
      </div>
      <div class="btn color-1 border-2 " v-if="SearchList.indexOf(item.name) > -1">
        已加入
      </div>
      <div class="btn color-1" v-else>
        +对比
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: '',
  data() {
    return {
      SchoolList: [],
      school_name: null,
      page: {
        pageNum: 1,
        pageSize: 5,
        total: 0
      },
      SearchList: []
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getCollege()
  },
  methods: {
    searchName() {
      this.pageNum = 1
      this.getCollege()
    },
    getCollege() {
      // this.loading = true
      let data = {}
      data.name = this.school_name
      data.pageNum = this.page.pageNum
      data.pageSize = this.page.pageSize
      data.score = this.userInfo.score
      this.$fecth.post('chat/chats/get_school_list', data).then((res) => {
        this.loading = false
        this.SchoolList = res.lists
      })
    },
    addSchool(e) {
      let key = this.SearchList.indexOf(e.name)
      if (key > -1) {
        this.SearchList.splice(key, 1);
      } else {
        let splen = this.SearchList.length;
        if (splen == 3) {
          this.$alert("最多对比3个院校", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          this.SearchList.push(e.name)
        }
      }
    },
    onSearch() {
      let splen = this.SearchList.length;
      if (splen < 2) {
        this.$alert("请最少选择2个院校", "提示", {
          confirmButtonText: "确定",
        });
        return false;
      } else {
        let data = {
          title: this.SearchList.join('/') + '请结合我的信息综合分析一下这几所院校的填报策略',
          SchoolList: this.SearchList,
          type: 4
        }
        this.$emit('getChat', data)
      }
    },
    getRefulsh() {
      this.page.pageNum++
      if (this.page.pageNum > 13) this.page.pageNum = 1
      this.getCollege()
    },
  },
};
</script>

<style scoped lang='less'>
.refulsh {
  color: #008BFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .huanyipi {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}



.search {
  margin-bottom: 20px
}

.school-item {
  display: flex;
  padding: 15px 15px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;

  .school-logo {
    width: 90px;
  }

  .school-info {
    flex: 1 1;
  }

  .btn {
    width: 50px;
    padding: 5px 10px;
    text-align: center;
    border-radius: 7px;
  }

  .school-name {
    font-size: 18px;
    line-height: 40px;

  }

  .school-desc {
    width: 600px;
    color: #929191;
    line-height: 30px;
  }
}

.school-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.search-list {
  display: flex;
  padding-bottom: 30px;
  justify-content: space-between;

  .search-list-content {
    display: flex;

    .search-list-item {
      padding: 4px 10px;
      margin-right: 20px;
      position: relative;
      border-radius: 3px;
    }

    .search-title {
      margin-right: 0;
    }
  }


}
</style>
